var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("ul", { staticClass: "nav nav-pills" }, [
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "summary" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/q/project/summary/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}`,
                  expression:
                    "`/#/q/project/summary/${workspaceId}/${tchProjectId}/${projectId}`",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Settings\n            ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "revenues" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/q/project/revenues/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}/${_vm.planId}`,
                  expression:
                    "`/#/q/project/revenues/${workspaceId}/${tchProjectId}/${projectId}/${planId}`",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Revenues\n            ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "resources" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/q/project/resource-allocations/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}/${_vm.planId}`,
                  expression:
                    "`/#/q/project/resource-allocations/${workspaceId}/${tchProjectId}/${projectId}/${planId}`",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Resources\n            ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "expenses" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/q/project/expense-allocations/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}/${_vm.planId}`,
                  expression:
                    "`/#/q/project/expense-allocations/${workspaceId}/${tchProjectId}/${projectId}/${planId}`",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Expenses\n            ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "capex" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/q/project/capex/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}/${_vm.planId}`,
                  expression:
                    "`/#/q/project/capex/${workspaceId}/${tchProjectId}/${projectId}/${planId}`",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Capex\n            ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "pnl" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/q/project/pnl/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}/${_vm.planId}`,
                  expression:
                    "`/#/q/project/pnl/${workspaceId}/${tchProjectId}/${projectId}/${planId}`",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                P&L\n            ")]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticClass: "mt-0 mb-4",
      staticStyle: { "border-color": "#bbb" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }